<div nz-row>
    <div nz-col [nzSm]="{span: 24}" [nzMd]="{span: 14, offset: 5}" [nzLg]="{span: 10, offset: 7}">
        <nz-card>
            <nz-result
                nzStatus="success"
                nzTitle="Registration Successful"
                [nzSubTitle]="verifiedMessage">
                <ng-template #verifiedMessage>
                    Thank you for registering. You will now be redirected to the login page...
                </ng-template>
            </nz-result>
        </nz-card>
    </div>
</div>
